import clsx from 'clsx';
import { getChildComponents } from '@adobe/aem-react-editable-components';
import { respGridUtil, TrackingPropsCarousel, TrackingPropsInterface } from '@marriott/mi-ui-library';
import { MaskItem, ThemeClusterCarouselMask } from './ThemeClusterCarouselMask.styles';
import { Model } from '@adobe/aem-spa-page-model-manager';

function whichCardVariationClass(variation: string) {
  if (variation === 'Tall2:3') {
    return 'tall';
  }

  return variation;
}

export function ThemeClusterCarouselPanelMask(props: {
  cqItems: Record<string, Model>;
  cqItemsOrder: string[];
  noOfCards?: number; // view count at breakpoint
  noOfCardsTablet?: number; // view count at breakpoint
  totalNumberOfCards?: string[];
}) {
  const {
    cqItems,
    cqItemsOrder,
    noOfCards: numberOfSlidesLarge,
    noOfCardsTablet: numberOfSlidesMedium,
    totalNumberOfCards,
  } = props;
  const totalNumberOfSlides = (totalNumberOfCards || []).length;

  return (
    <ThemeClusterCarouselMask>
      {cqItemsOrder.map(cardKey => {
        const model = respGridUtil(cqItems[cardKey]);

        const { cqItems: cardCqItems, cqItemsOrder: cardCqItemsOrder } = model;
        const childComponents = getChildComponents({
          cqItems: cardCqItems,
          cqItemsOrder: cardCqItemsOrder,
        });

        const processedComponents = childComponents.map(ChildComponent => {
          const { model: childModel } = ChildComponent.props;

          return (
            <MaskItem
              className={clsx(
                'fill-element skeleton-loader',
                whichCardVariationClass(childModel.cardLayeredVariations)
              )}
              $numberOfSlidesLarge={numberOfSlidesLarge}
              $numberOfSlidesMedium={numberOfSlidesMedium}
              $totalNumberOfSlides={totalNumberOfSlides}
            >
              {childModel.cardLayeredVariations}
            </MaskItem>
          );
        });

        if (!processedComponents?.length) return null;

        return processedComponents;
      })}
    </ThemeClusterCarouselMask>
  );
}
